import { GQLCartShippingMethodType, GQLOperationalSettingsFragment, GQLStoreBaseFragment } from '@theprintbar/graphql';
import { getCurrencyValue, invariant, isDefined } from '../../utils';

interface ShippingPriceProps {
	settings: GQLOperationalSettingsFragment;
	weight: number;
	shippingMethod?: GQLCartShippingMethodType;
	store?: GQLStoreBaseFragment | null;
}

export function getShippingPrice({ settings, weight, shippingMethod, store }: ShippingPriceProps) {
	if (!shippingMethod || shippingMethod === GQLCartShippingMethodType.Pickup) return 0;

	const shipping =
		shippingMethod === GQLCartShippingMethodType.International
			? settings.internationalShipping.structure
			: shippingMethod === GQLCartShippingMethodType.Express
			? settings.expressShipping.structure
			: settings.regularShipping.structure;

	invariant(shipping?.pricing, 'No shipping details found');

	const matchingPrice = shipping.pricing
		.filter(isDefined)
		.find(({ minWeight, maxWeight }) => typeof minWeight === 'number' && weight >= minWeight && (!maxWeight || weight <= maxWeight));

	invariant(matchingPrice, 'Missing shipping method pricing');

	let price = getCurrencyValue(!!store ? matchingPrice.partnerPortalPrice : matchingPrice.websitePrice);
	if (store?.shippingDiscount) {
		price = price - (price * parseInt(store.shippingDiscount)) / 100;
	}

	if (weight > 5000) {
		//get the kg over 5kg
		const overWeightGrams = weight - 5000;
		const overWeightKg = Math.round(overWeightGrams / 1000);
		price += getCurrencyValue(!!store ? shipping.partnerPortalCostPerExcessKG : shipping.websiteCostPerExcessKG) * overWeightKg;
	}

	return getCurrencyValue(price);
}
